export default "__VITE_ASSET__e75cd3e0__"